import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { TransitionGroup } from "react-transition-group";
import { COLOR_GREY_6 } from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";
import IconButton from "@mui/material/IconButton";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_GREY_6)};
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
`;

export const StyledTransitionGroup = styled(TransitionGroup)`
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`;

export const StyledIconButton = styled(IconButton)`
  align-self: flex-end;
`;